import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-120" }
const _hoisted_2 = { class: "bg-white rounded p-6 flex flex-col md:h-full overflow-y-auto" }
const _hoisted_3 = { class: "flex flex-row text-medium justify-between items-center mb-8" }
const _hoisted_4 = { class: "w-5/6 font-bold text-black" }
const _hoisted_5 = { class: "w-1/12 text-right" }
const _hoisted_6 = { class: "bg-primary-blue p-2 rounded text-white font-bold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "w-1/12" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportsSupplierSummary = _resolveComponent("ReportsSupplierSummary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("report.suppliers.title")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.reportData?.parcels_count || "-"), 1)
        ]),
        _hoisted_7
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportData.report_per_suppliers, (supplier) => {
        return (_openBlock(), _createBlock(_component_ReportsSupplierSummary, {
          supplier: supplier,
          key: supplier.id
        }, null, 8, ["supplier"]))
      }), 128))
    ])
  ]))
}